// extracted by mini-css-extract-plugin
module.exports = {"link-list":"LinkList_link-list__StNn1","item":"LinkList_item__VvElS"};